<template>
  <aside class="dialog" v-if="opened">
    <div class="main">
      <div class="block">
        <slot></slot>
      </div>
    </div>
  </aside>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Dialog',
  data() {
    return {
      opened: false,
    };
  },
  methods: {
    open() {
      document.body.classList.add('loading');
      this.opened = true;
    },
    close() {
      this.opened = false;
      document.body.classList.remove('loading');
    },
  },
});
</script>

<style lang="scss" scoped>
.dialog {
  z-index: 4;
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(#000, 0.1);

  .main {
    overflow: auto;
    width: calc(100% - 30px);
    max-width: 480px;
    max-height: calc(100% - 30px);
    border-radius: 15px;
    box-shadow: 0 0 10px var(--bs-gray-400);
    background-color: var(--bs-white);
  }

  .block {
    padding: 20px;
  }
}
</style>
